import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import ProductsList from '@/views/product/ProductsList.vue'
import ProductDetail from '@/views/product/ProductDetail.vue'
import Loading from '@/plugins/loading'
import store from "@/store";
import i18n from '@/i18n'
Vue.use(VueRouter)

// 支持的语言列表
const SUPPORTED_LANGUAGES = ['zh', 'en', 'ja', 'ko', 'ru', 'es', 'fr', 'ar']

// 基础路由配置
const baseRoutes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
    meta: {
      breadcrumb: { name: '首页' }
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/product/index.vue'),
    meta: {
      breadcrumb: { name: '产品中心' }
    }
  },
  {
    path: '/ProductsSearch',
    name: 'productsSearch',
    component: () => import('@/views/product/ProductsSearchPage.vue'),
    meta: {
      breadcrumb: { name: '产品中心搜索' }
    }
  },
  {
    path: '/about-yacoo',
    name: 'about',
    component: () => import('@/views/about/about.vue'),
    meta: {
      breadcrumb: { name: '关于亚科' }
    }
  },
  {
    path: '/about-yacoo/:component',
    name: 'about',
    component: () => import('@/views/about/about.vue'),
    meta: {
      breadcrumb: { name: '关于亚科' }
    }
  },
  {
    path: '/about-us/company',
    name: 'AboutCompany',
    component: () => import('@/views/about/CompanyPage.vue'),
    meta: {
      breadcrumb: { name: '关于亚科' }
    }
  },
  {
    path: '/about-us/production',
    name: 'AboutProduction',
    component: () => import('@/views/about/ProductionPage.vue'),
    meta: {
      breadcrumb: { name: '关于亚科' }
    }
  },
  {
    path: '/contact-us',
    name: 'AboutContact',
    component: () => import('@/views/about/ContactPage.vue'),
    meta: {
      breadcrumb: { name: '关于亚科' }
    }
  },
  {
    path: '/about-us/qualityControl',
    name: 'QualityControl',
    component: () => import('@/views/about/QualityControl.vue'),
    meta: {
      breadcrumb: { name: '关于亚科' }
    }
  },
  {
    path: '/information-center',
    name: 'news',
    component: () => import('@/views/NewsPage.vue'),
    meta: {
      breadcrumb: { name: '资讯中心' }
    }
  },
  {
    path: '/information-center/:component',
    name: 'news',
    component: () => import('@/views/NewsPage.vue'),
    meta: {
      breadcrumb: { name: '资讯中心' }
    }
  },
  {
    path: '/sustainable-development',
    name: 'sustainability',
    component: () => import('@/views/SustainabilityPage.vue'),
    meta: {
      breadcrumb: { name: '可持续发展' }
    }
  },
  {
    path: '/careers',
    name: 'careers',
    component: () => import('@/views/about/CareersPage.vue'),
    meta: {
      breadcrumb: { name: '加入我们' }
    }
  },
  {
    path: '/careersDetails',
    name: 'careersDetails',
    component: () => import('@/views/about/CareersDetails.vue'),
    meta: {
      breadcrumb: { name: '加入我们' }
    }
  },
  {
    path: '/products/list/:id',
    name: 'ProductsList',
    component: ProductsList,
    meta: {
      breadcrumb: { name: '产品列表' }
    }
  },
  {
    path: '/products/Document',
    name: 'ProductsDocument',
    component: () => import('@/views/product/Document.vue'),
    meta: {
      breadcrumb: { name: '产品列表' }
    }
  },
  {
    path: '/products/:id',
    name: 'ProductDetail',
    component: ProductDetail,
    meta: {
      breadcrumb: { name: '产品详情' },
      dynamicBreadcrumb: (route) => {
        return route.params.name || null;
      }
    }
  },
  {
    path: '/information-center/:component/:id',
    name: 'NewsDetails',
    component: () => import('@/views/NewsDetails.vue'),
    meta: {
        breadcrumb: { name: '新闻详情' }
    }
  },
  {
    path: '/searchPage',
    name: 'SearchPage',
    component: () => import('@/views/SearchPage.vue'),
    meta: {
      breadcrumb: { name: '搜索结果' }
    }
  },
  {
    path: '/other-businesses/scientific-research-procurement',
    name: 'KyCg',
    component: () => import('@/views/other/kycg.vue'),
    meta: {
      breadcrumb: { name: '其他服务' }
    }
  },
  {
    path: '/other-businesses',
    name: 'DzHc',
    component: () => import('@/views/other/dzhc.vue'),
    meta: {
      breadcrumb: { name: '其他服务' }
    }
  },
  {
    path: '/other-businesses/custom-synthesis',
    name: 'DzHc',
    component: () => import('@/views/other/dzhc.vue'),
    meta: {
      breadcrumb: { name: '其他服务' }
    }
  },
  {
    path: '/other-businesses/testing-services',
    name: 'JcFw',
    component: () => import('@/views/other/jcfw.vue'),
    meta: {
      breadcrumb: { name: '其他服务' }
    }
  },
  {
    path: '/other-businesses/green-energy',
    name: 'LsNy',
    component: () => import('@/views/other/lsny.vue'),
    meta: {
      breadcrumb: { name: '其他服务' }
    }
  },
  {
    path: '/industry-solutions',
    name: 'Solution',
    component: () => import('@/views/solution/index.vue'),
    meta: {
      breadcrumb: { name: '产品解决方案' }
    }
  },
  {
    path: '/innovation-production',
    name: 'Technology',
    component: () => import('@/views/technology.vue')
  },
  {
    path: '/innovation-production/:component',
    name: 'TechnologyComponent',
    component: () => import('@/views/technology.vue')
  },
  {
    path: '/industry-solutions/:component',
    name: 'solutionModel',
    component: () => import('@/views/solution/model.vue')
  },
  {
    path: '/Agreement',
    name: 'Agreement',
    component: () => import('@/views/Agreement.vue')
  },
  {
    path: '/TermsOfService',
    name: 'TermsOfService',
    component: () => import('@/views/TermsOfService.vue')
  }
]

// 生成多语言路由
const generateLanguageRoutes = () => {
  const routes = []
  
  // 为每种语言生成路由
  SUPPORTED_LANGUAGES.forEach(lang => {
    baseRoutes.forEach(route => {
      const languageRoute = {
        ...route,
        path: `/${lang}${route.path}`,
        name: `${lang}_${route.name}`,
        meta: {
          ...route.meta,
          language: lang
        }
      }
      routes.push(languageRoute)
    })
  })
  
  // 添加默认路由（无语言前缀）
  routes.push(...baseRoutes)
  
  return routes
}

const routes = generateLanguageRoutes()

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL || '/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

//获取当前语言，缓存优先
const getBrowserLang = () => {
  const savedLanguage = localStorage.getItem('language')
  if (savedLanguage && i18n.messages.hasOwnProperty(savedLanguage)) {
    return savedLanguage
  }

  const browserLang = navigator.language || navigator.userLanguage
  const langCode = browserLang.toLowerCase()
  const language = langCode.split('-')[0]

  // 检查是否支持该语言
  if (i18n.messages[language]) {
    return language
  }

  // 如果不支持，返回相近的语言或默认语言
  if (langCode.startsWith('en')) {
    return 'en'
  }
  return 'en'
}

// 从路径中提取语言
const extractLanguageFromPath = (path) => {
  const segments = path.split('/').filter(segment => segment)
  if (segments.length > 0 && SUPPORTED_LANGUAGES.includes(segments[0])) {
    return segments[0]
  }
  return null
}

// 设备检测配置
const DEVICE_CONFIG = {
  MOBILE_BREAKPOINT: 768, // 移动端断点
  TABLET_BREAKPOINT: 1024, // 平板断点
  MOBILE_HOST: 'mobile.yacoo.com.cn',
  PC_HOST: 'www.yacoo.com.cn'
}

// 增强的设备检测函数
export const isMobile = () => {
  // 优先使用视窗宽度判断
  if (typeof window !== 'undefined') {
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if (viewportWidth <= DEVICE_CONFIG.MOBILE_BREAKPOINT) {
      return true;
    }
  }
  
  // 备用方案：使用User Agent检测
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

// 获取设备类型
export const getDeviceType = () => {
  if (typeof window === 'undefined') return 'unknown';
  
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  
  if (viewportWidth <= DEVICE_CONFIG.MOBILE_BREAKPOINT) {
    return 'mobile';
  } else if (viewportWidth <= DEVICE_CONFIG.TABLET_BREAKPOINT) {
    return 'tablet';
  } else {
    return 'desktop';
  }
}

// 检查是否需要重定向
const shouldRedirect = (to) => {
  // 预渲染环境中不进行重定向
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }
  
  const deviceType = getDeviceType();
  const currentHost = window.location.hostname;
  
  // 移动端设备访问PC端域名时需要重定向
  if (deviceType === 'mobile' && currentHost !== DEVICE_CONFIG.MOBILE_HOST) {
    return true;
  }
  
  // PC端设备访问移动端域名时需要重定向
  if (deviceType === 'desktop' && currentHost === DEVICE_CONFIG.MOBILE_HOST) {
    return true;
  }
  
  return false;
}

// 执行重定向
const performRedirect = (to, deviceType) => {
  const path = to.path.startsWith('/') ? to.path : '/' + to.path;
  const targetHost = deviceType === 'mobile' ? DEVICE_CONFIG.MOBILE_HOST : DEVICE_CONFIG.PC_HOST;
  const protocol = window.location.protocol;
  
  // 构建完整的URL，包含查询参数和哈希
  let fullUrl = `${protocol}//${targetHost}${path}`;
  
  // 添加查询参数
  if (to.query && Object.keys(to.query).length > 0) {
    const queryString = new URLSearchParams(to.query).toString();
    fullUrl += `?${queryString}`;
  }
  
  // 添加哈希
  if (to.hash) {
    fullUrl += to.hash;
  }
  
  window.location.href = fullUrl;
}

// 监听窗口大小变化
let resizeTimeout;
const handleResize = () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const deviceType = getDeviceType();
    const currentHost = window.location.hostname;
    
    // 如果设备类型发生变化且当前域名不匹配，则重定向
    if (shouldRedirect({ path: window.location.pathname })) {
      // 构建完整的路由对象，包含查询参数和哈希
      const fullRoute = {
        path: window.location.pathname,
        query: Object.fromEntries(new URLSearchParams(window.location.search)),
        hash: window.location.hash
      };
      performRedirect(fullRoute, deviceType);
    }
  }, 300); // 防抖延迟
}

// 在客户端环境下添加窗口大小监听
if (typeof window !== 'undefined') {
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
}

router.beforeEach((to, from, next) => {
  // 预渲染环境中简化处理
  if (typeof window === 'undefined' || !window.location) {
    next();
    return;
  }
  
  const deviceType = getDeviceType();
  
  // 检查是否需要重定向
  if (shouldRedirect(to)) {
    performRedirect(to, deviceType);
    return;
  }
  
  // 处理多语言路由
  let currentLanguage = 'zh';
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      currentLanguage = localStorage.getItem('language') || getBrowserLang();
    } else {
      currentLanguage = getBrowserLang();
    }
  } catch (e) {
    currentLanguage = getBrowserLang();
  }
  const pathLanguage = extractLanguageFromPath(to.path)
  
  // 如果路径中没有语言前缀，重定向到带语言前缀的路径
  if (!pathLanguage && currentLanguage !== 'en') {
    const newPath = `/${currentLanguage}${to.path}`
    // 添加检查，避免重定向到相同路径
    if (newPath !== to.path) {
      // 保留查询参数和哈希
      next({ 
        path: newPath, 
        query: to.query,
        hash: to.hash,
        replace: true 
      })
      return
    }
  }
  
  // 如果路径中有语言前缀，更新当前语言设置
  if (pathLanguage && pathLanguage !== currentLanguage) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem('language', pathLanguage)
      }
    } catch (e) {
      // 预渲染环境可能无法访问 localStorage
    }
    i18n.locale = pathLanguage
    store.dispatch('setLanguage', pathLanguage)
  }
  
  // 如果当前已经在正确的域名，直接放行
  const currentHost = typeof window !== 'undefined' && window.location ? window.location.hostname : 'localhost';
  const isCorrectHost = (deviceType === 'mobile' && currentHost === DEVICE_CONFIG.MOBILE_HOST) ||
                       (deviceType === 'desktop' && currentHost !== DEVICE_CONFIG.MOBILE_HOST);
  
  if (isCorrectHost) {
    // 根据设备类型决定是否显示Loading
    if (deviceType === 'desktop') {
      Loading.show();
    }
    next();
    return;
  }
  
  // 其他情况，默认放行
  next();
});

router.afterEach(() => {
  Loading.hide()
})


export default router
